import type { ArticleBlockLinkBoxProps } from "./ShowArticleProps.d";

import React from 'react';

import { Anchor } from '/react4xp/components/Element';
import { LinkIcon } from "../infoLinkCards/LinkIcon";


export const LinkBlock: React.FC<ArticleBlockLinkBoxProps> = ({ title, subtitle, links }) => {
	return (
		<div className="article article__rich-text-container flex flex-col mb-xl">
			{title && <h2>{title}</h2>}
			{subtitle && <p>{subtitle}</p>}
			{links && (
				links.map((link, index) => {
					return (
						<Anchor
							key={index}
							href={link.link?.href}
							className={[
								'!text-neutral',
								'align-middle',
								'border-action-primary-default',
								'border-solid',
								'border',
								'cursor-pointer',
								'flex',
								'hover:bg-surface-action-secondary-hover',
								'justify-between',
								'mb-xs',
								'no-underline',
								'px-lg',
								'py-sm',
								'rounded-sm',
							]}
						>
							<span>
								{link.linkText}
								{link.link?.hostname ? ` (${link.link.hostname})` : null}
							</span>
							<LinkIcon
								className='self-center text-prussianblue'
								link={link.link}
							/>
						</Anchor>
					);
				})
			)}
		</div>
	);
};
